import Quill from 'quill'

const Embed = Quill.import('blots/embed')

export default class VariableBlot extends Embed {
  static blotName = 'variable'
  static tagName = 'span'
  static className = 'ql-inserted-variable'

  static create(value) {
    const node = super.create()
    node.setAttribute('data-name', value)
    node.setAttribute('contenteditable', 'false')
    node.innerText = `{${value}}`
    return node
  }

  static value(node) {
    return node.getAttribute('data-name')
  }
}
